import {
  AuthErrorKind,
  ChangePasswordErrorTypes,
  ReauthErrorKind,
} from '@griply/types';

// Outcomes a form already renders; an `unknown` kind is reported where it is thrown.
const expectedMutationErrors = new Set<string>([
  ...Object.values(AuthErrorKind).filter(
    (kind) => kind !== AuthErrorKind.Unknown,
  ),
  ChangePasswordErrorTypes.WrongPassword,
  ChangePasswordErrorTypes.WeakPassword,
  ReauthErrorKind.WrongPassword,
  ReauthErrorKind.Cancelled,
]);

export const isExpectedMutationError = (error: unknown): boolean => {
  const kind = (error as { kind?: unknown } | null)?.kind;

  return typeof kind === 'string' && expectedMutationErrors.has(kind);
};
